/**
 * EL GUION DEL MENTOR EN CATALAN, para las lecciones escritas en catalan (hoy, el curso de
 * Historia de la Filosofia de la PAU de Catalunya). Entra el 12 de octubre de 2026: hasta hoy la
 * leccion estaba en catalan y Socrates saludaba, elogiaba y se despedia en castellano, y solo el
 * cierre de conceptos cambiaba de idioma.
 *
 * MISMAS CLAVES Y MISMO NUMERO DE FRASES que `socratesScript.js`, y cada una dice lo mismo que su
 * pareja: no es otro guion, es el mismo traducido. Si una frase cambia alli, cambia aqui. Lo
 * vigila `scripts/prueba_guionCatalan.mjs`.
 *
 * CATALAN SENCILLO, como pidio Gabri para todo el curso: «evitamos palabras raras en catalán que
 * no se parezcan en nada al español». Quien lo lee es un alumno de 2.º de Bachillerato.
 */
export const GUION_CA = {
  WELCOMES: [
    "Hola! Quina alegria veure't per aquí. 👋",
    "Bones! Ja tenia ganes que arribessis.",
    "Hola de nou! Posa't còmode, que avui porto una cosa bona.",
    "Ei! M'alegro de veure't. Som-hi.",
  ],
  PRAISE: [
    "Correcte! 🎯",
    "Això és! Molt bé.",
    "Molt bé! Continua així.",
    "Exacte! Ho tens dominat.",
    "Genial! Era aquesta.",
    "Bum! Ni un dubte.",
  ],
  GREETINGS: [
    "Som-hi, avui parlarem d'un tema molt interessant. Què saps de «{tema}»?",
    "Avui ens posem amb una cosa que val la pena. Abans de res, explica'm: què saps de «{tema}»?",
    "Sense pressió, eh? Només per curiositat: què et ve al cap quan dic «{tema}»?",
    "Comencem per tu. Què és el que ja saps sobre «{tema}»? Encara que sigui una intuïció.",
  ],
  RECOGNITIONS: [
    "D'acord, ja sé d'on partim. Sobre aquesta base, t'explico la resta.",
    "Gràcies, amb això ja me'n faig una idea. Deixa'm afegir un parell de coses.",
    "Apuntat. A veure què canvia d'aquí al final, que per això comencem.",
    "Bé, ja tinc per on començar. T'explico una mica més.",
    "Perfecte, això em serveix. Anem amb el que se'n sap.",
  ],
  REPREGUNTAS: [
    "Ha, ha, hola. Però va de debò: encara que sigui una intuïció, què et ve al cap?",
    "Això no em diu gaire 😄. Digues el que sigui, encara que creguis que no hi té res a veure.",
    "Et llegeixo, però necessito una mica més. Una paraula sola ja em val.",
  ],
  SIN_IDEA: [
    "Doncs millor: així tot el que ve ara és nou. Som-hi.",
    "Perfecte, per això som aquí. Comencem de zero.",
    "Em val, i és més honest que inventar-se alguna cosa. T'explico.",
  ],
  FLATTERIES: [
    "Quina gran pregunta!",
    "M'agrada com penses...",
    "Fixa't que aquesta és la clau de tot...",
    "Uf, has tocat un punt important.",
    "Boníssima. Just aquí hi ha el que és interessant.",
  ],
  RETURN_HOOKS: [
    "...però no ens avancem massa. Continuem amb el que estàvem veient?",
    "...i de fet, això connecta perfectament amb el que t'anava a explicar ara.",
    "Dit això, a punt per continuar?",
    "T'ho lligo amb el d'abans quan continuem, ja veuràs.",
  ],
  FALLBACK_ANSWERS: [
    "Molt bon dubte. La resposta curta és que depèn del context, però tranquil: ho veuràs molt clar quan continuem amb el temari.",
    "M'encanta que preguntis això. Guarda't la idea un segon, perquè just el que t'anava a explicar ara la respon gairebé sencera.",
  ],
  PRE_ACTIVITY: [
    "Ara et posaré a prova amb unes preguntes, a veure com et va.",
    "Ara et toca a tu. Unes preguntes ràpides per veure com vas.",
  ],
  CIERRE_DUDA: [
    "Abans de marxar: t'ha quedat alguna pregunta del que hem vist?",
    "Una última cosa. Hi ha alguna cosa d'avui que t'hagi quedat a mitges?",
    "Et queda algun dubte d'això? Pregunta'm i te'l resolc abans de tancar.",
  ],
  FAREWELL:
    "Bé, crec que necessito un refresc i unes patates ben bones. Si vols, vine, que convido jo. Has fet una bona feina.",
  REPASA: "Repassa els conceptes clau. Quan els hagis vist tots, seguim.",
  aviso: (n) => (n === 1
    ? "Avís: ara ve una pregunta i la teoria s'atura aquí."
    : `Avís: ara vénen ${n} preguntes i la teoria s'atura aquí.`),
};
